export default __webpack_public_path__ + "e4a09066a2132f6a7412aff90917636d.svg";